import {Component, OnDestroy, OnInit, ChangeDetectionStrategy} from '@angular/core';
import {ShadeServiceProps, ShadeToolsService, ShadeToolType, UserSharingDialogProps} from '../../../core/services/shade-tools.service';
import {Subject, Subscription} from 'rxjs';
import {Tile} from '../../../shared/models/tile';
import {DialogBoxComponent} from '../../components/dialog-box/dialog-box.component';
import {UserSharingDialogBoxComponent} from '../../components/user-sharing-dialog-box/user-sharing-dialog-box.component';


@Component({
  selector: 'motn-shade-tools',
  templateUrl: './shade-tools.component.html',
  styleUrls: ['./shade-tools.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    DialogBoxComponent,
    UserSharingDialogBoxComponent,
  ],
})
export class ShadeToolsComponent implements OnInit, OnDestroy {
  private subs: Subscription[] = [];

  ShadeToolType = ShadeToolType
  currentShadeToolType: ShadeToolType = ShadeToolType.Empty;
  props: ShadeServiceProps = {};
  userSharingDialogProps: UserSharingDialogProps = {};

  constructor(
    private shadeToolsService: ShadeToolsService,
  ) {
  }

  ngOnInit(): void {
    const sub = this.shadeToolsService.incrementer.subscribe(
      () => {
        // Here we need to ensure that all properties of this class that are
        // references to properties in ShadeToolsService get set to the properties
        // in ShadeToolsService because we've just been informed that the service
        // has been instructed to render something new
        this.props = this.shadeToolsService.props;
        this.userSharingDialogProps = this.shadeToolsService.userSharingDialogProps;
        this.currentShadeToolType = this.shadeToolsService.currentShadeToolType;
      },
    );

    this.subs.push(sub);
  }

  ngOnDestroy() {
    this.subs.map(sub => sub.unsubscribe());
  }

  onUserSharingDialogClose(): void {
    this.shadeToolsService.closeModal(ShadeToolType.SHADE_USER_SHARING_DIALOG_BOX);
  }

}
